<!--
 * @Author: 仙道
 * @Date: 2022-06-18 21:05:21
 * @LastEditTime: 2022-07-23 23:28:08
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/monitor/points/modules/IotModelPointsModalForDetail.vue
-->
<template>
  <j-modal
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    :title="title"
    :visible="visible"
    :width="width"
    @cancel="handleCancel"
    @ok="handleOk"
    cancelText="关闭"
    switchFullscreen
  >
    <iot-list-all
      :deviceData="deviceData"
      :disabled="disableSubmit"
      :idType="idType"
      @ok="submitCallback"
      ref="realForm"
    />
  </j-modal>
</template>

<script>

  import IotListAll from './IotListAll.vue'
  export default {
    name: 'IotModelPointsModal',
    components: {
      IotListAll
    },
    props: {
      deviceData: {
        type: Object,
        default: () => { }
      },
      idType: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        title: '',
        width: 1200,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      add () {
        this.visible = true
        this.$nextTick(() => {
          const pageId = this.deviceData && this.deviceData.id ? this.deviceData.id : ''
          this.$refs.realForm.add(pageId, this.idType)
        })
      },
      edit (record) {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.edit(record)
        })
      },
      close () {
        this.$emit('close')
        this.visible = false
      },
      handleOk () {
        this.$refs.realForm.submitForm()
      },
      submitCallback(data) {
          this.$emit('ok', data);
          this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>
